// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"notificationBanner_bannerContainer__TDIiH","link":"notificationBanner_link__1jf8z","closeIcon":"notificationBanner_closeIcon__3dVg5"};